import React, { useState } from "react";
import styled from "styled-components";
import { formatSlots } from "components/raffle/utils";
import Button from "@material-ui/core/Button";
import ConfirmationModal from "components/modify/ConfirmationModal";

export const InfoBoxInstructions = ({
  updateWinners,
  selection,
  id,
  hasRaffleSlots,
}) => {
  const [saveConfirmationModalOpen, setSaveConfirmationModalOpen] =
    useState(false);
  return (
    <Wrapper>
      How to use:!
      <p>
        - Below you can see a up to date list of all the players who have
        applied for each raffle slot.
      </p>
      <p>
        - To predetermine a winner, please select them in the list for a slot.
      </p>
      <p>
        - Once you have made your choices hit the save button. This will save
        your choices, but
        <b>
          <i className={"important"}> will not resolve the slots.</i>
        </b>
      </p>
      <p>
        - When you are ready to resolve the slots, type
        <strong> !raffle {id}</strong> into a discord channel that the slotting
        bot can see. This will then run the raffle and update the slots for you.
      </p>
      <p>
        - You can edit/save this page as many times as you like before running
        the raffle command. Result are only final once you run the raffle
        command.
      </p>
      <Wrapper>
        <Button
          id="button"
          variant="contained"
          color="secondary"
          disabled={!hasRaffleSlots}
          onClick={() => {
            setSaveConfirmationModalOpen(true);
          }}
        >
          SAVE
        </Button>
      </Wrapper>
      <ConfirmationModal
        isOpen={saveConfirmationModalOpen}
        setIsOpen={setSaveConfirmationModalOpen}
        onClickYes={({ setIsOpen, setSnackBarOpen }) => {
          console.log("yes");
          setIsOpen(false);
          updateWinners({ slots: formatSlots(selection), id });
          setSnackBarOpen(true);
        }}
        onClickNo={({ setIsOpen }) => {
          setIsOpen(false);
        }}
        mainBodyText={
          <div>
            <p>Are you sure you want to save these raffle results?</p>
            <i>You can always edit later.</i>
          </div>
        }
        errorText={"Updated raffle winners."}
        snackBarAutoHideDuration={10000}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  border-style: solid;
  border-color: #3b618ccc;
  border-radius: 8px;
  background-color: #292b2f;
  border-width: 2px;
  padding: 5px;
  margin: 10px;

  > button {
    min-width: 100px;
  }
`;

export default InfoBoxInstructions;
